// extracted by mini-css-extract-plugin
export default {"container":"Home_container__k26hR","logo":"Home_logo__VZstE","getStartedButton":"Home_getStartedButton__-rU74"};